import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
};

export type AggregateChatHistory = {
  _count?: Maybe<ChatHistoryCountAggregateOutputType>;
  _max?: Maybe<ChatHistoryMaxAggregateOutputType>;
  _min?: Maybe<ChatHistoryMinAggregateOutputType>;
};

export type AggregateChatRoom = {
  _count?: Maybe<ChatRoomCountAggregateOutputType>;
  _max?: Maybe<ChatRoomMaxAggregateOutputType>;
  _min?: Maybe<ChatRoomMinAggregateOutputType>;
};

export type BatchPayload = {
  count: Scalars['Int']['output'];
};

export type ChatHistory = {
  ChatRoom: ChatRoom;
  chatRoomId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role: MessageRole;
};

export type ChatHistoryCountAggregateOutputType = {
  _all: Scalars['Int']['output'];
  chatRoomId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['Int']['output'];
  role: Scalars['Int']['output'];
};

export type ChatHistoryCountOrderByAggregateInput = {
  chatRoomId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
};

export type ChatHistoryCreateInput = {
  ChatRoom: ChatRoomCreateNestedOneWithoutChatHistoriesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  role: MessageRole;
};

export type ChatHistoryCreateManyChatRoomInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  role: MessageRole;
};

export type ChatHistoryCreateManyChatRoomInputEnvelope = {
  data: Array<ChatHistoryCreateManyChatRoomInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatHistoryCreateManyInput = {
  chatRoomId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  role: MessageRole;
};

export type ChatHistoryCreateNestedManyWithoutChatRoomInput = {
  connect?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatHistoryCreateOrConnectWithoutChatRoomInput>>;
  create?: InputMaybe<Array<ChatHistoryCreateWithoutChatRoomInput>>;
  createMany?: InputMaybe<ChatHistoryCreateManyChatRoomInputEnvelope>;
};

export type ChatHistoryCreateOrConnectWithoutChatRoomInput = {
  create: ChatHistoryCreateWithoutChatRoomInput;
  where: ChatHistoryWhereUniqueInput;
};

export type ChatHistoryCreateWithoutChatRoomInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  role: MessageRole;
};

export type ChatHistoryGroupByOutputType = {
  _count?: Maybe<ChatHistoryCountAggregateOutputType>;
  _max?: Maybe<ChatHistoryMaxAggregateOutputType>;
  _min?: Maybe<ChatHistoryMinAggregateOutputType>;
  chatRoomId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role: MessageRole;
};

export type ChatHistoryListRelationFilter = {
  every?: InputMaybe<ChatHistoryWhereInput>;
  none?: InputMaybe<ChatHistoryWhereInput>;
  some?: InputMaybe<ChatHistoryWhereInput>;
};

export type ChatHistoryMaxAggregateOutputType = {
  chatRoomId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  role?: Maybe<MessageRole>;
};

export type ChatHistoryMaxOrderByAggregateInput = {
  chatRoomId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
};

export type ChatHistoryMinAggregateOutputType = {
  chatRoomId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  role?: Maybe<MessageRole>;
};

export type ChatHistoryMinOrderByAggregateInput = {
  chatRoomId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
};

export type ChatHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ChatHistoryOrderByWithAggregationInput = {
  _count?: InputMaybe<ChatHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<ChatHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<ChatHistoryMinOrderByAggregateInput>;
  chatRoomId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
};

export type ChatHistoryOrderByWithRelationInput = {
  ChatRoom?: InputMaybe<ChatRoomOrderByWithRelationInput>;
  chatRoomId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
};

export enum ChatHistoryScalarFieldEnum {
  chatRoomId = 'chatRoomId',
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  id = 'id',
  message = 'message',
  role = 'role'
}

export type ChatHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<ChatHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChatHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<ChatHistoryScalarWhereInput>>;
  chatRoomId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumMessageRoleFilter>;
};

export type ChatHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ChatHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ChatHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ChatHistoryScalarWhereWithAggregatesInput>>;
  chatRoomId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  message?: InputMaybe<StringWithAggregatesFilter>;
  role?: InputMaybe<EnumMessageRoleWithAggregatesFilter>;
};

export type ChatHistoryUncheckedCreateInput = {
  chatRoomId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  role: MessageRole;
};

export type ChatHistoryUncheckedCreateNestedManyWithoutChatRoomInput = {
  connect?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatHistoryCreateOrConnectWithoutChatRoomInput>>;
  create?: InputMaybe<Array<ChatHistoryCreateWithoutChatRoomInput>>;
  createMany?: InputMaybe<ChatHistoryCreateManyChatRoomInputEnvelope>;
};

export type ChatHistoryUncheckedCreateWithoutChatRoomInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  role: MessageRole;
};

export type ChatHistoryUncheckedUpdateInput = {
  chatRoomId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MessageRole>;
};

export type ChatHistoryUncheckedUpdateManyInput = {
  chatRoomId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MessageRole>;
};

export type ChatHistoryUncheckedUpdateManyWithoutChatRoomInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MessageRole>;
};

export type ChatHistoryUncheckedUpdateManyWithoutChatRoomNestedInput = {
  connect?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatHistoryCreateOrConnectWithoutChatRoomInput>>;
  create?: InputMaybe<Array<ChatHistoryCreateWithoutChatRoomInput>>;
  createMany?: InputMaybe<ChatHistoryCreateManyChatRoomInputEnvelope>;
  delete?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatHistoryUpdateWithWhereUniqueWithoutChatRoomInput>>;
  updateMany?: InputMaybe<Array<ChatHistoryUpdateManyWithWhereWithoutChatRoomInput>>;
  upsert?: InputMaybe<Array<ChatHistoryUpsertWithWhereUniqueWithoutChatRoomInput>>;
};

export type ChatHistoryUncheckedUpdateWithoutChatRoomInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MessageRole>;
};

export type ChatHistoryUpdateInput = {
  ChatRoom?: InputMaybe<ChatRoomUpdateOneRequiredWithoutChatHistoriesNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MessageRole>;
};

export type ChatHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MessageRole>;
};

export type ChatHistoryUpdateManyWithWhereWithoutChatRoomInput = {
  data: ChatHistoryUpdateManyMutationInput;
  where: ChatHistoryScalarWhereInput;
};

export type ChatHistoryUpdateManyWithoutChatRoomNestedInput = {
  connect?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatHistoryCreateOrConnectWithoutChatRoomInput>>;
  create?: InputMaybe<Array<ChatHistoryCreateWithoutChatRoomInput>>;
  createMany?: InputMaybe<ChatHistoryCreateManyChatRoomInputEnvelope>;
  delete?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatHistoryUpdateWithWhereUniqueWithoutChatRoomInput>>;
  updateMany?: InputMaybe<Array<ChatHistoryUpdateManyWithWhereWithoutChatRoomInput>>;
  upsert?: InputMaybe<Array<ChatHistoryUpsertWithWhereUniqueWithoutChatRoomInput>>;
};

export type ChatHistoryUpdateWithWhereUniqueWithoutChatRoomInput = {
  data: ChatHistoryUpdateWithoutChatRoomInput;
  where: ChatHistoryWhereUniqueInput;
};

export type ChatHistoryUpdateWithoutChatRoomInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MessageRole>;
};

export type ChatHistoryUpsertWithWhereUniqueWithoutChatRoomInput = {
  create: ChatHistoryCreateWithoutChatRoomInput;
  update: ChatHistoryUpdateWithoutChatRoomInput;
  where: ChatHistoryWhereUniqueInput;
};

export type ChatHistoryWhereInput = {
  AND?: InputMaybe<Array<ChatHistoryWhereInput>>;
  ChatRoom?: InputMaybe<ChatRoomScalarRelationFilter>;
  NOT?: InputMaybe<Array<ChatHistoryWhereInput>>;
  OR?: InputMaybe<Array<ChatHistoryWhereInput>>;
  chatRoomId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumMessageRoleFilter>;
};

export type ChatHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<ChatHistoryWhereInput>>;
  ChatRoom?: InputMaybe<ChatRoomScalarRelationFilter>;
  NOT?: InputMaybe<Array<ChatHistoryWhereInput>>;
  OR?: InputMaybe<Array<ChatHistoryWhereInput>>;
  chatRoomId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumMessageRoleFilter>;
};

export type ChatRoom = {
  ChatHistories: Array<ChatHistory>;
  _count: ChatRoomCountOutputType;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type ChatRoomChatHistoriesArgs = {
  cursor?: InputMaybe<ChatHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<InputMaybe<ChatHistoryScalarFieldEnum>>>;
  orderBy?: InputMaybe<Array<InputMaybe<ChatHistoryOrderByWithRelationInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ChatHistoryWhereInput>;
};

export type ChatRoomCountAggregateOutputType = {
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  deletedAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
};

export type ChatRoomCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ChatRoomCountOutputType = {
  ChatHistories: Scalars['Int']['output'];
};

export type ChatRoomCreateInput = {
  ChatHistories?: InputMaybe<ChatHistoryCreateNestedManyWithoutChatRoomInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ChatRoomCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ChatRoomCreateNestedOneWithoutChatHistoriesInput = {
  connect?: InputMaybe<ChatRoomWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatRoomCreateOrConnectWithoutChatHistoriesInput>;
  create?: InputMaybe<ChatRoomCreateWithoutChatHistoriesInput>;
};

export type ChatRoomCreateOrConnectWithoutChatHistoriesInput = {
  create: ChatRoomCreateWithoutChatHistoriesInput;
  where: ChatRoomWhereUniqueInput;
};

export type ChatRoomCreateWithoutChatHistoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ChatRoomGroupByOutputType = {
  _count?: Maybe<ChatRoomCountAggregateOutputType>;
  _max?: Maybe<ChatRoomMaxAggregateOutputType>;
  _min?: Maybe<ChatRoomMinAggregateOutputType>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ChatRoomList = {
  data: Array<ChatRoom>;
  total: Scalars['Int']['output'];
};

export type ChatRoomMaxAggregateOutputType = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatRoomMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ChatRoomMinAggregateOutputType = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatRoomMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ChatRoomOrderByWithAggregationInput = {
  _count?: InputMaybe<ChatRoomCountOrderByAggregateInput>;
  _max?: InputMaybe<ChatRoomMaxOrderByAggregateInput>;
  _min?: InputMaybe<ChatRoomMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ChatRoomOrderByWithRelationInput = {
  ChatHistories?: InputMaybe<ChatHistoryOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum ChatRoomScalarFieldEnum {
  createdAt = 'createdAt',
  createdBy = 'createdBy',
  deletedAt = 'deletedAt',
  id = 'id',
  name = 'name'
}

export type ChatRoomScalarRelationFilter = {
  is?: InputMaybe<ChatRoomWhereInput>;
  isNot?: InputMaybe<ChatRoomWhereInput>;
};

export type ChatRoomScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ChatRoomScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ChatRoomScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ChatRoomScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type ChatRoomUncheckedCreateInput = {
  ChatHistories?: InputMaybe<ChatHistoryUncheckedCreateNestedManyWithoutChatRoomInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ChatRoomUncheckedCreateWithoutChatHistoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ChatRoomUncheckedUpdateInput = {
  ChatHistories?: InputMaybe<ChatHistoryUncheckedUpdateManyWithoutChatRoomNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChatRoomUncheckedUpdateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChatRoomUncheckedUpdateWithoutChatHistoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChatRoomUpdateInput = {
  ChatHistories?: InputMaybe<ChatHistoryUpdateManyWithoutChatRoomNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChatRoomUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChatRoomUpdateOneRequiredWithoutChatHistoriesNestedInput = {
  connect?: InputMaybe<ChatRoomWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ChatRoomCreateOrConnectWithoutChatHistoriesInput>;
  create?: InputMaybe<ChatRoomCreateWithoutChatHistoriesInput>;
  update?: InputMaybe<ChatRoomUpdateToOneWithWhereWithoutChatHistoriesInput>;
  upsert?: InputMaybe<ChatRoomUpsertWithoutChatHistoriesInput>;
};

export type ChatRoomUpdateToOneWithWhereWithoutChatHistoriesInput = {
  data: ChatRoomUpdateWithoutChatHistoriesInput;
  where?: InputMaybe<ChatRoomWhereInput>;
};

export type ChatRoomUpdateWithoutChatHistoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ChatRoomUpsertWithoutChatHistoriesInput = {
  create: ChatRoomCreateWithoutChatHistoriesInput;
  update: ChatRoomUpdateWithoutChatHistoriesInput;
  where?: InputMaybe<ChatRoomWhereInput>;
};

export type ChatRoomWhereInput = {
  AND?: InputMaybe<Array<ChatRoomWhereInput>>;
  ChatHistories?: InputMaybe<ChatHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<ChatRoomWhereInput>>;
  OR?: InputMaybe<Array<ChatRoomWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ChatRoomWhereUniqueInput = {
  AND?: InputMaybe<Array<ChatRoomWhereInput>>;
  ChatHistories?: InputMaybe<ChatHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<ChatRoomWhereInput>>;
  OR?: InputMaybe<Array<ChatRoomWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
};

export type CreateManyChatHistoryAndReturnOutputType = {
  ChatRoom: ChatRoom;
  chatRoomId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role: MessageRole;
};

export type CreateManyChatRoomAndReturnOutputType = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type EnumMessageRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<MessageRole>;
};

export type EnumMessageRoleFilter = {
  equals?: InputMaybe<MessageRole>;
  in?: InputMaybe<Array<MessageRole>>;
  not?: InputMaybe<NestedEnumMessageRoleFilter>;
  notIn?: InputMaybe<Array<MessageRole>>;
};

export type EnumMessageRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumMessageRoleFilter>;
  _min?: InputMaybe<NestedEnumMessageRoleFilter>;
  equals?: InputMaybe<MessageRole>;
  in?: InputMaybe<Array<MessageRole>>;
  not?: InputMaybe<NestedEnumMessageRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<MessageRole>>;
};

export enum MessageRole {
  assistant = 'assistant',
  system = 'system',
  user = 'user'
}

export type Mutation = {
  createChatRoom: ChatRoom;
  deleteChatRoom: ChatRoom;
  sendChat: ChatRoom;
  updateChatRoom: ChatRoom;
};


export type MutationCreateChatRoomArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteChatRoomArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendChatArgs = {
  chatRoomId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationUpdateChatRoomArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumMessageRoleFilter = {
  equals?: InputMaybe<MessageRole>;
  in?: InputMaybe<Array<MessageRole>>;
  not?: InputMaybe<NestedEnumMessageRoleFilter>;
  notIn?: InputMaybe<Array<MessageRole>>;
};

export type NestedEnumMessageRoleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumMessageRoleFilter>;
  _min?: InputMaybe<NestedEnumMessageRoleFilter>;
  equals?: InputMaybe<MessageRole>;
  in?: InputMaybe<Array<MessageRole>>;
  not?: InputMaybe<NestedEnumMessageRoleWithAggregatesFilter>;
  notIn?: InputMaybe<Array<MessageRole>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  first = 'first',
  last = 'last'
}

export type Query = {
  chatRoom: ChatRoom;
  chatRoomList: ChatRoomList;
};


export type QueryChatRoomArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatRoomListArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export enum QueryMode {
  default = 'default',
  insensitive = 'insensitive'
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum TransactionIsolationLevel {
  ReadCommitted = 'ReadCommitted',
  ReadUncommitted = 'ReadUncommitted',
  RepeatableRead = 'RepeatableRead',
  Serializable = 'Serializable'
}

export type UpdateManyChatHistoryAndReturnOutputType = {
  ChatRoom: ChatRoom;
  chatRoomId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role: MessageRole;
};

export type UpdateManyChatRoomAndReturnOutputType = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ChatRoomRowFragment = { id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, role: MessageRole, message: string, createdAt: string, createdBy?: string | null, chatRoomId: string }> };

export type ChatRoomsRowFragment = { id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, createdAt: string, createdBy?: string | null }> };

export type ChatRoomListQueryVariables = Exact<{
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatRoomListQuery = { chatRoomList: { total: number, data: Array<{ id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, createdAt: string, createdBy?: string | null }> }> } };

export type ChatRoomQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ChatRoomQuery = { chatRoom: { id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, role: MessageRole, message: string, createdAt: string, createdBy?: string | null, chatRoomId: string }> } };

export type CreateChatRoomMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateChatRoomMutation = { createChatRoom: { id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, createdAt: string, createdBy?: string | null }> } };

export type UpdateChatRoomMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateChatRoomMutation = { updateChatRoom: { id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, createdAt: string, createdBy?: string | null }> } };

export type DeleteChatRoomMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteChatRoomMutation = { deleteChatRoom: { id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, createdAt: string, createdBy?: string | null }> } };

export type SendChatMutationVariables = Exact<{
  chatRoomId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type SendChatMutation = { sendChat: { id: string, name: string, createdAt: string, createdBy: string, ChatHistories: Array<{ id: string, role: MessageRole, message: string, createdAt: string, createdBy?: string | null, chatRoomId: string }> } };

export const ChatRoomRowFragmentDoc = gql`
    fragment ChatRoomRow on ChatRoom {
  id
  name
  createdAt
  createdBy
  ChatHistories {
    id
    role
    message
    createdAt
    createdBy
    chatRoomId
  }
}
    `;
export const ChatRoomsRowFragmentDoc = gql`
    fragment ChatRoomsRow on ChatRoom {
  id
  name
  createdAt
  createdBy
  ChatHistories {
    id
    createdAt
    createdBy
  }
}
    `;
export const ChatRoomListDocument = gql`
    query ChatRoomList($keyword: String) {
  chatRoomList(keyword: $keyword) {
    total
    data {
      ...ChatRoomsRow
    }
  }
}
    ${ChatRoomsRowFragmentDoc}`;

/**
 * __useChatRoomListQuery__
 *
 * To run a query within a React component, call `useChatRoomListQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatRoomListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatRoomListQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useChatRoomListQuery(baseOptions?: Apollo.QueryHookOptions<ChatRoomListQuery, ChatRoomListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatRoomListQuery, ChatRoomListQueryVariables>(ChatRoomListDocument, options);
      }
export function useChatRoomListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatRoomListQuery, ChatRoomListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatRoomListQuery, ChatRoomListQueryVariables>(ChatRoomListDocument, options);
        }
export function useChatRoomListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatRoomListQuery, ChatRoomListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatRoomListQuery, ChatRoomListQueryVariables>(ChatRoomListDocument, options);
        }
export type ChatRoomListQueryHookResult = ReturnType<typeof useChatRoomListQuery>;
export type ChatRoomListLazyQueryHookResult = ReturnType<typeof useChatRoomListLazyQuery>;
export type ChatRoomListSuspenseQueryHookResult = ReturnType<typeof useChatRoomListSuspenseQuery>;
export type ChatRoomListQueryResult = Apollo.QueryResult<ChatRoomListQuery, ChatRoomListQueryVariables>;
export const ChatRoomDocument = gql`
    query ChatRoom($id: ID!) {
  chatRoom(id: $id) {
    ...ChatRoomRow
  }
}
    ${ChatRoomRowFragmentDoc}`;

/**
 * __useChatRoomQuery__
 *
 * To run a query within a React component, call `useChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatRoomQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatRoomQuery(baseOptions: Apollo.QueryHookOptions<ChatRoomQuery, ChatRoomQueryVariables> & ({ variables: ChatRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatRoomQuery, ChatRoomQueryVariables>(ChatRoomDocument, options);
      }
export function useChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatRoomQuery, ChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatRoomQuery, ChatRoomQueryVariables>(ChatRoomDocument, options);
        }
export function useChatRoomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatRoomQuery, ChatRoomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatRoomQuery, ChatRoomQueryVariables>(ChatRoomDocument, options);
        }
export type ChatRoomQueryHookResult = ReturnType<typeof useChatRoomQuery>;
export type ChatRoomLazyQueryHookResult = ReturnType<typeof useChatRoomLazyQuery>;
export type ChatRoomSuspenseQueryHookResult = ReturnType<typeof useChatRoomSuspenseQuery>;
export type ChatRoomQueryResult = Apollo.QueryResult<ChatRoomQuery, ChatRoomQueryVariables>;
export const CreateChatRoomDocument = gql`
    mutation CreateChatRoom($name: String!) {
  createChatRoom(name: $name) {
    ...ChatRoomsRow
  }
}
    ${ChatRoomsRowFragmentDoc}`;

/**
 * __useCreateChatRoomMutation__
 *
 * To run a mutation, you first call `useCreateChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatRoomMutation, { data, loading, error }] = useCreateChatRoomMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateChatRoomMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatRoomMutation, CreateChatRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatRoomMutation, CreateChatRoomMutationVariables>(CreateChatRoomDocument, options);
      }
export type CreateChatRoomMutationHookResult = ReturnType<typeof useCreateChatRoomMutation>;
export type CreateChatRoomMutationResult = Apollo.MutationResult<CreateChatRoomMutation>;
export type CreateChatRoomMutationOptions = Apollo.BaseMutationOptions<CreateChatRoomMutation, CreateChatRoomMutationVariables>;
export const UpdateChatRoomDocument = gql`
    mutation UpdateChatRoom($id: ID!, $name: String!) {
  updateChatRoom(id: $id, name: $name) {
    ...ChatRoomsRow
  }
}
    ${ChatRoomsRowFragmentDoc}`;

/**
 * __useUpdateChatRoomMutation__
 *
 * To run a mutation, you first call `useUpdateChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatRoomMutation, { data, loading, error }] = useUpdateChatRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateChatRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatRoomMutation, UpdateChatRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatRoomMutation, UpdateChatRoomMutationVariables>(UpdateChatRoomDocument, options);
      }
export type UpdateChatRoomMutationHookResult = ReturnType<typeof useUpdateChatRoomMutation>;
export type UpdateChatRoomMutationResult = Apollo.MutationResult<UpdateChatRoomMutation>;
export type UpdateChatRoomMutationOptions = Apollo.BaseMutationOptions<UpdateChatRoomMutation, UpdateChatRoomMutationVariables>;
export const DeleteChatRoomDocument = gql`
    mutation DeleteChatRoom($id: ID!) {
  deleteChatRoom(id: $id) {
    ...ChatRoomsRow
  }
}
    ${ChatRoomsRowFragmentDoc}`;

/**
 * __useDeleteChatRoomMutation__
 *
 * To run a mutation, you first call `useDeleteChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatRoomMutation, { data, loading, error }] = useDeleteChatRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatRoomMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatRoomMutation, DeleteChatRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatRoomMutation, DeleteChatRoomMutationVariables>(DeleteChatRoomDocument, options);
      }
export type DeleteChatRoomMutationHookResult = ReturnType<typeof useDeleteChatRoomMutation>;
export type DeleteChatRoomMutationResult = Apollo.MutationResult<DeleteChatRoomMutation>;
export type DeleteChatRoomMutationOptions = Apollo.BaseMutationOptions<DeleteChatRoomMutation, DeleteChatRoomMutationVariables>;
export const SendChatDocument = gql`
    mutation SendChat($chatRoomId: ID!, $message: String!) {
  sendChat(chatRoomId: $chatRoomId, message: $message) {
    ...ChatRoomRow
  }
}
    ${ChatRoomRowFragmentDoc}`;

/**
 * __useSendChatMutation__
 *
 * To run a mutation, you first call `useSendChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatMutation, { data, loading, error }] = useSendChatMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendChatMutation(baseOptions?: Apollo.MutationHookOptions<SendChatMutation, SendChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChatMutation, SendChatMutationVariables>(SendChatDocument, options);
      }
export type SendChatMutationHookResult = ReturnType<typeof useSendChatMutation>;
export type SendChatMutationResult = Apollo.MutationResult<SendChatMutation>;
export type SendChatMutationOptions = Apollo.BaseMutationOptions<SendChatMutation, SendChatMutationVariables>;